@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBackReview {

  &.tiny {
    .review {
      font-size: 15px !important;
    }
  }

  .title {
    font-size: 28px;
    margin-bottom: 15px;

    @include texts.font("semi-bold");
  }

  .content {
    display: flex;
    gap: 20px;

    .left {
      height: 67px;
      width: 67px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 67px;

      &.white {
        .blur {
          background: var(--white);
        }

        .icon {
          filter: var(--icon-white);
        }
      }

      .blur {
        background: var(--web-blue-light);
        filter: blur(22px);
        width: 44px;
        height: 44px;
        position: absolute;
      }

      .icon {
        height: 67px;
        width: 67px;
        position: absolute;
        filter: var(--icon-blue-black-web);

        @include icons.ico("black-quote");
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      margin-top: 13px;
      gap: 6px;
      font-size: 15px;

      .stars {
        display: flex;
        gap: 2px;
        margin-bottom: 5px;

        .star {
          height: 19px;
          width: 19px;
          filter: var(--icon-blue-black-web);

          @include icons.ico("black-star");
        }
      }

      .link {
        display: flex;
        gap: 8px;
        font-size: 17px;
        align-items: center;
        cursor: pointer;
        color: var(--web-blue-light);

        &:hover {
          text-decoration: underline;
        }

        .icon {
          height: 12px;
          width: 12px;
          margin-top: 1px;
          filter: var(--icon-blue-black-web);

          @include icons.ico("black-right-arrow");
        }
      }

      .bottom {
        display: flex;
        align-items: center;
        margin-top: 15px;

        .person {
          padding-right: 15px;

          .name {
            font-size: 24px;

            @include texts.font("semi-bold");
          }

          .role {
            font-size: 14px;
          }
        }

        .stats {
          margin-left: 20px;
          position: relative;
          z-index: 1;
          display: flex;
          gap: 25px;
          padding-left: 20px;
          border-left: 1px solid var(--web-blue-light);

          .stat {
            .value {
              color: var(--web-blue);
              font-size: 24px;
              text-align: center;

              @include texts.font("semi-bold");
            }

            .label {
              color: var(--white);
              text-align: center;
            }
          }
        }
      }
    }
  }

  @media (max-width: 930px) {

    .left {
      height: 34px !important;
      width: 34px !important;
      flex: 0 0 34px !important;
      margin-top: 20px !important;

      .blur {
        filter: blur(14px) !important;
        width: 24px !important;
        height: 24px !important;
      }

      .icon {
        height: 34px !important;
        width: 34px !important;
      }
    }

    .right {
      position: relative;
      z-index: 1;

      .name {
        font-size: 17px !important;
      }
    }

    .review {
      font-size: 15px !important;
    }

    .link {
      font-size: 15px !important;
    }

    .stats {
      .stat {
        display: none;

        &:first-child {
          display: block !important;
        }

        .value {
          font-size: 17px !important;
        }

        .label {
          font-size: 14px !important;
        }
      }
    }
  }
}